import { useDialog } from "naive-ui";

export function useAlertDialog() {
  const dialog = useDialog();

  return (message: string, title = "알림"): Promise<void> => {
    return new Promise((resolve) => {
      dialog.info({
        title,
        content: message,
        positiveText: "확인",
        showIcon: true,
        closable: false,
        maskClosable: false,
        onPositiveClick: () => {
          resolve();
        },
      });
    });
  };
}
